import React, { forwardRef } from 'react';

import { DropdownArrowCIcon } from '~/assets/images';

const OlcDropdownChevron = forwardRef(
  (
    {
      className = '',
      disabled = false,
      open,
      style = {},
      tone = 'dark',
      ...imageProps
    },
    ref
  ) => {
    const isOpen = open ?? className.includes('MuiSelect-iconOpen');

    return (
      <img
        {...imageProps}
        ref={ref}
        aria-hidden="true"
        alt=""
        className={`olcDropdownChevron${isOpen ? ' olcDropdownChevron--open' : ''} ${className}`.trim()}
        src={DropdownArrowCIcon}
        style={{
          ...style,
          filter: tone === 'light' ? 'brightness(0) invert(1)' : style.filter,
          height: '5px',
          opacity: disabled ? 0.38 : style.opacity,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transformOrigin: 'center',
          transition: 'transform 0.3s ease',
          width: '10px',
        }}
      />
    );
  }
);

OlcDropdownChevron.displayName = 'OlcDropdownChevron';

export default OlcDropdownChevron;
